import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import FloatingCTA from "./components/FloatingCTA";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Home from "./pages/Home/Home";
import WhyChooseUs from "./pages/WhyChooseUs/WhyChooseUs";
import AboutUs from "./pages/AboutUs/AboutUs";
import SmoothScroll from "./components/SmoothScroll";
import Sample from "./pages/Sample/Sample";
import OurWorks from "./pages/OurWorks/OurWorks";
import OurProcess from "./pages/OurProcess/OurProcess";
import ContactUs from "./pages/ContactUs/ContactUs";
import AIChatBot from "./components/AIChatBot";

function App() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    const handleToggleChat = () => setIsChatOpen(prev => !prev);
    window.addEventListener("toggle-ai-chat", handleToggleChat);
    return () => window.removeEventListener("toggle-ai-chat", handleToggleChat);
  }, []);

  return (
    <Router>
      <SmoothScroll isChatOpen={isChatOpen}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/sample" element={<Sample />} />
          <Route path="/our-works" element={<OurWorks />} />
          <Route path="/our-process" element={<OurProcess />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        <Footer />
        <FloatingCTA />
        <AIChatBot isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
      </SmoothScroll>
    </Router>
  );
}

export default App;
